import React from "react";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import { TextField, Stack, Spinner, SpinnerSize } from "@fluentui/react";
import OrderDetailTxt from "../../../orders/components/forms/edditOrder/OrderDetailTxt";
import { useConfirmValidator } from "../../hooks/useConfirmValidator";
import { useValidatorData } from "../../../orders/hooks/useValidatorData";
import { renderValidatorMessage } from "../../actions/renderValidatorMessage";

export interface OrderFormProps {
  cancelForm: any;
  reception: number;
  orderTypeItemId: number;
}

const ConfirmValidatorForm: React.FC<OrderFormProps> = ({ cancelForm, reception, orderTypeItemId }) => {
  const { t } = useTranslation("admin");
  const { selectedValidators } = useValidatorData();
  const { comment, setComment, handleSubmit, isLoading } = useConfirmValidator(cancelForm);

  return (
    <>
      <Formik
        initialValues={{
          quantity: "1",
          reception: { reception },
          orderTypeItemId: { orderTypeItemId },
        }}
        onSubmit={(e: any) => handleSubmit(e)}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {() => (
          <form onSubmit={(e) => handleSubmit(e)}>
            <Stack tokens={{ childrenGap: 15 }}>
              <OrderDetailTxt
                title={t("nav.createdDate") as string}
                value={selectedValidators[0].createdDateStr}
              />
              <OrderDetailTxt
                title={t("nav.itemDescription") as string}
                value={renderValidatorMessage(selectedValidators[0], t)}
              />
              <TextField
                name="additionalInfo"
                label={t("nav.comment") as string}
                value={comment}
                onChange={(e, newValue) => setComment(newValue || "")}
                multiline
              />
              <NewFormBtns
                positionAbsolute={true}
                submitBtnText={t("nav.confirm") as string}
                cancelForm={cancelForm}
                disabled={isLoading}
              />
            </Stack>
          </form>
        )}
      </Formik>
      {isLoading && <Spinner size={SpinnerSize.large} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />}
    </>
  );
};

export default ConfirmValidatorForm;
